import React, { useRef } from 'react';

import Slider from 'react-slick';

import IndustryCard from './IndustryCard';

interface IndustryCardType {
  type: string;
  title: string;
  link: {
    url: string;
    text: string;
  };
  imageUrl: string;
}

export interface IndustryCardsProps {
  cards: IndustryCardType[];
  theme?: 'light' | 'dark';
}

function IndustryCards({ cards, theme = 'light' }: IndustryCardsProps) {
  const sliderRef = useRef(null);

  const settings = {
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      className={`au-w-full ${
        theme === 'dark' ? 'au-bg-gray-900' : 'au-bg-white'
      }`}
    >
      <div className="industry-card-container au-max-w-outer au-mx-auto">
        <Slider ref={sliderRef} {...settings}>
          {cards.map(card => (
            <IndustryCard card={card} theme={theme} />
          ))}
        </Slider>
      </div>
    </div>
  );
}

IndustryCards.attributes = {
  theme: {
    type: 'string',
    default: 'light',
  },
  cards: {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          required: true,
        },
        title: {
          type: 'string',
          required: true,
        },
        link: {
          type: 'object',
          properties: {
            url: {
              type: 'string',
              required: true,
            },
            text: {
              type: 'string',
              required: true,
            },
          },
        },
        imageUrl: {
          type: 'string',
          required: true,
        },
      },
    },
  },
};

export default IndustryCards;
